import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import history from '../../../router/browserrouter';
import {store} from "../../store";
export default function* watcherGetInventoryCountSaga() {
    yield takeEvery("LOAD_INVENTORY_COUNT", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER", payload: payload })
        var payload = {}
        var formatUrl = 'api/Admin/get-user-location-dropdown?userId='+localStorage.getItem("userId")
        yield request("get", {}, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "LOCATIONS_LIST_DROPDOWN", payload: payload })

        formatUrl = 'api/Admin/get-product-dropdown?id=' + localStorage.getItem("companyId")
        yield request("get", {}, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "PRODUCT_DROPDOWN_LIST", payload: payload })
        formatUrl = 'get-inventory-count-details'
        yield request("get", {}, formatUrl).then(response => {
            payload = response;
        });
        console.log(payload)
        yield put({ type: "INVENTORY_COUNT_LIST", payload: payload })
        yield put({ type: "DISPLAY_LOADER"})
    } catch (e) {
        yield put({ type: "DISPLAY_LOADER", payload: payload })
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        console.log("LOCATIONS-saga", e)
        console.log("locations-saga", e.response)
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
